import React from 'react';

export type ChipVariant = 'accent' | 'success' | 'warn' | 'danger' | 'info' | 'neutral';

interface ChipProps {
  variant?: ChipVariant;
  children: React.ReactNode;
  dot?: boolean;
  lg?: boolean;
  style?: React.CSSProperties;
}

export default function Chip({ variant = 'neutral', children, dot, lg, style }: ChipProps) {
  return (
    <span className={`t-chip ${variant}${lg ? ' lg' : ''}`} style={style}>
      {dot && <span className="dot" />}
      {children}
    </span>
  );
}
